<template>
  <div v-if="!loading" class="review-preview">
    <div class="review-preview__title">
      <!-- <h4>{{ showRelevantReviews ? 'Most Relevant Reviews' : 'User Reviews' }}</h4> -->
      <h4>Most Relevant Reviews</h4>
      <p v-if="showRelevantReviews">
        Kondisi kulit & rambutmu berubah? Biar rekomendasi beauties-mu tetap relevan,
        <a :href="`${$store.state.SOCO_WEB_URL}/profile/beauty`" target="blank_" rel="noopener noreferrer"
          >update di sini yuk!</a
        >
      </p>
    </div>
    <div
      v-if="showRelevantReviews || (isLogin && !isBeautyProfileCompleted) || !isLogin"
      class="review-preview__relevant-beauty"
    >
      <UserBeautyTags v-if="showRelevantReviews" :product="product"></UserBeautyTags>
      <div v-else class="review-preview__relevant-beauty--complete-bp">
        <template v-if="isLogin">
          <p v-if="!isBeautyProfileCompleted">
            Takut produk kurang cocok? Dapatkan rekomendasi beauties yang sesuai untukmu, dengan
            <a :href="`${$store.state.SOCO_WEB_URL}/beauty-profile`" target="blank_" rel="noopener noreferrer"
              >isi beauty profile di sini!</a
            >
          </p>
          <strong>+150 <img src="/assets/img/icon_sp.svg" class="lazy-img sp-icon" /></strong>
        </template>
        <p v-else>
          Login / Register untuk mendapatkan review yang lebih relevan dengan beauty profile kamu.
          <a href="" @click.prevent="loginOtf">Login sekarang</a>
        </p>
      </div>
    </div>
    <ul :class="['review-preview__review', { 'no-overflow': isActionDropdownOpened }]">
      <li
        v-for="(review, index) in reviews"
        :key="index"
        class="review-content"
        :class="{
          'expert-review':
            (review.user && review.user.is_expert_reviewer) || (review.owner && review.owner.is_expert_reviewer),
        }"
      >
        <!-- RATING AND REVIEWER NAME -->
        <div class="flex space-between flex-start">
          <div class="flex review-rating">
            <GRatingInline
              v-if="review.average_rating"
              class-modifier="average-rating--uniform"
              :average-rating="review.average_rating.toFixed(1)"
              :star-fill-number="review.average_rating * 10"
            />
            <img
              v-if="
                (review.user && review.user.is_expert_reviewer) || (review.owner && review.owner.is_expert_reviewer)
              "
              src="/assets/img/expert-review-check-icon.svg"
              class="trusted-review__icon"
              height="16"
              width="16"
              alt="icon-expert"
              style="margin-left: 8px"
            />
            <img
              v-else-if="review.is_verified_purchase"
              :src="
                isDesktop
                  ? '/assets/img/icon-shopper-label-v2.svg'
                  : '/assets/img/expert-review/shopper-review-white.svg'
              "
              class="trusted-review__icon"
              :height="isDesktop ? 16 : 17"
              :width="isDesktop ? 16 : 17"
              alt="icon-trusted-review"
              style="margin-left: 8px"
            />
          </div>
          <span class="review-name">{{ reviewer(review) }}</span>
        </div>
        <!-- VARIANT -->
        <div class="review-content--variant">
          <span v-if="review.product.variant" class="review-variant">{{ formatVariant(review.product.variant) }}</span>
          <span
            v-else-if="review.product.combination"
            class="review-variant"
            v-html="showProductDetail(review.product.combination)"
          ></span>
        </div>
        <!-- REVIEW TEXT -->
        <div v-if="String(review.details).length > 150" class="review-content--text">
          <div v-if="review.is_read_more">
            <p class="review-text">{{ review.details }}</p>
            <span class="review-read-more" @click.prevent="toggleReadMore(review.is_read_more, index)"
              >(read less)</span
            >
          </div>
          <div v-else>
            <p class="review-text">
              <span>{{ review.details | trimRecentReviewContentMobile }}</span>
              <span class="review-read-more" @click.prevent="showModalReview(review)">(Read more)</span>
            </p>
          </div>
        </div>
        <div v-else class="review-content--text">
          <p class="review-text">{{ review.details }}</p>
        </div>
        <!-- PHOTO -->
        <UserPhoto
          v-if="$SO.size(review.images)"
          :key="`list-user-photo-${review['_id']}`"
          :average-rating="review.average_rating ? review.average_rating : 0"
          :details="review.details ? review.details : ''"
          :images="review.images"
          :created_at="review.created_at"
          :user="review.user"
          :max_photo="3"
          class="review-photo"
        >
          <p v-if="$SO.size(review.images) > 3" slot="last-item" class="list-user-photo__last-item-text text-uppercase">
            +{{ $SO.size(review.images) - 3 }}
          </p>
        </UserPhoto>
        <!-- ACTION -->
        <div class="flex space-between mt-auto">
          <div class="review-likes">
            <span
              v-if="isLogin"
              class="btn-action journal-icon--uniform helpful"
              :class="{ active: review.has_liked }"
              @click="like(review, index)"
              >Helpful {{ review.total_likes ? `(${review.total_likes})` : '' }}</span
            >
            <span
              v-else
              class="btn-action journal-icon--uniform helpful"
              :class="{ active: review.has_liked }"
              @click="loginOtf"
              >Helpful {{ review.total_likes ? `(${review.total_likes})` : '' }}</span
            >
            <span class="btn-action journal-icon--uniform share margin-left-10" @click.prevent="modalShare(review)"
              >Share</span
            >
          </div>
          <div class="review-action">
            <template v-if="review.is_own_review && isLogin">
              <a
                href=""
                class="journal-icon--uniform more"
                @click.prevent="toggleDropdown(review.is_action_dropdown_open, index)"
              ></a>
              <div v-if="review.is_action_dropdown_open" class="action-top-card-dropdown--uniform active">
                <a v-if="review.is_own_review && review.is_editable" href="" @click.prevent="editReview(review)">
                  <span class="journal-icon--uniform edit">Edit Review</span>
                </a>
                <a
                  v-if="review.is_own_review && isLogin"
                  href=""
                  @click.prevent="requestToDelete(review.newsfeed_id, index)"
                >
                  <span class="journal-icon--uniform request-delete">Request to Delete</span>
                </a>
              </div>
            </template>
            <div v-else class="journal-icon--uniform report">
              <a v-if="review.has_reported && isLogin" href="" @click.prevent=""> </a>
              <a
                v-else-if="!review.has_reported && isLogin"
                href=""
                @click.prevent="openModalReport(review.newsfeed_id, index)"
              >
              </a>
              <a v-else href="" @click.prevent="loginOtf"> </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="reviewsCount > 5" class="review-preview__see-more-review">
      <p @click="seeMore">See more reviews ({{ reviewsCount | cnvrtNumberToK }})</p>
    </div>
    <!-- MODAL -->
    <ModalReport />

    <g-modal v-if="showReadMoreReview" id="pills-dropdown-mobile" class="normalize-gutter">
      <template slot="header">
        <div class="rectangle-top"></div>
        <div class="modal-heading">
          <h4 class="modal-heading--title">Read More Review</h4>
          <button
            type="button"
            class="close modal-heading--close"
            data-dismiss="modal"
            aria-label="Close"
            @click="showReadMoreReview = false"
          >
            <img src="/assets/img/icon-close.svg" height="14" width="14" />
          </button>
        </div>
      </template>
      <template slot="body">
        <CardReviewDetailModal
          v-if="selectedReadMoreReview"
          :show-product="false"
          :review-data="selectedReadMoreReview"
          on="product"
        />
      </template>
    </g-modal>
  </div>
</template>

<script>
import { get } from 'lodash';
import Auth from '@/shared/auth';
import CardReviewDetailModal from '@/components/dashboard/snippet/card-review-detail-modal';
export default {
  name: 'FilteredReviewsPreview',
  components: {
    UserBeautyTags: () => import('@/components/product/product-detail/snippet/user-beauty-tags'),
    UserPhoto: () => import('@/components/dashboard/snippet/list-user-photo'),
    ModalReport: () => import('@/components/global/modal/modal-report'),
    CardReviewDetailModal,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      reviews: [],
      reviewsCount: 0,
      loading: true,
      showReadMoreReview: false,
      selectedReadMoreReview: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.userProfile;
    },
    userSkinType() {
      return this.user.beauty.reduce((result, beauty) => {
        if (beauty.name === 'jenis-kulit' || beauty.name === 'kondisi-kulit') {
          result = [...result, ...beauty.subtags];
        }
        return result;
      }, []);
    },
    userHairType() {
      return this.user.beauty.reduce((result, beauty) => {
        if (beauty.name.includes('rambut')) {
          result = [...result, ...beauty.subtags];
        }
        return result;
      }, []);
    },
    isBeautyProfileCompleted() {
      const { user } = this;
      return (
        user &&
        user.beauty &&
        user.beauty.length &&
        !this.$SO.isEmptyObject(user.beauty.find((beauty) => beauty.type === 'beauty-profile'))
      );
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isActionDropdownOpened() {
      return this.reviews.find((review) => review.is_action_dropdown_open);
    },
    isRelevantSkinType() {
      return this.userSkinType.some((skin) => {
        if (
          this.reviews[0] &&
          this.reviews[0].user &&
          this.reviews[0].user.skin_types &&
          this.reviews[0].user.skin_types.length
        ) {
          return Boolean(this.reviews[0].user.skin_types.some((type) => type._id === skin._id));
        }
      });
    },
    isRelevantHairType() {
      return this.userHairType.some((skin) => {
        if (
          this.reviews[0] &&
          this.reviews[0].user &&
          this.reviews[0].user.hair_types &&
          this.reviews[0].user.hair_types.length
        ) {
          return Boolean(this.reviews[0].user.hair_types.some((type) => type._id === skin._id));
        }
      });
    },
    showRelevantReviews() {
      return this.isLogin && this.isBeautyProfileCompleted && (this.isRelevantSkinType || this.isRelevantHairType);
    },
    productId() {
      const id = this.$route.params.product_id.split('-');
      if (id[0]) {
        return id[0];
      } else {
        return null;
      }
    },
    filter() {
      const filter = {
        is_published: true,
        elastic_search: true,
      };
      if (this.productId) {
        filter['product_id'] = this.productId;
      }
      return filter;
    },
    sort() {
      if (this.isLogin) {
        if (this.isBeautyProfileCompleted) {
          return 'most_relevant';
        } else {
          return '-total_likes';
        }
      } else {
        return '-total_likes';
      }
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  async created() {
    await Promise.all([this.fetchReview(), this.fetchReviewCount()]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    async fetchReview() {
      return new Promise((resolve, reject) => {
        try {
          const { sort, filter } = this;
          resolve(
            this.$MS_SOCO_PUBLIC_API_URL.get(`/reviews`, {
              params: {
                sort,
                filter: {
                  ...filter,
                  is_highlight: true,
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then((response) => {
        const reviews = get(response, 'data.data', []);
        this.reviews = reviews.map((review) => {
          return {
            ...review,
            is_own_review: review.user.id === (this.$store.state.userProfile && this.$store.state.userProfile._id),
            is_action_dropdown_open: false,
            is_read_more: false,
          };
        });
      });
    },
    async fetchReviewCount() {
      return new Promise((resolve, reject) => {
        try {
          const { filter } = this;
          resolve(
            this.$MS_SOCO_PUBLIC_API_URL.get(`/reviews/count`, {
              params: { filter },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then((response) => {
        this.reviewsCount = get(response, 'data.data', 0);
      });
    },
    async like({ newsfeed_id, total_likes = 0 }, index) {
      return new Promise((resolve, reject) => {
        try {
          resolve(this.$MS_SOCO_PUBLIC_API_URL.post(`/newsfeed/${newsfeed_id}/likes`));
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          const liked = response.data.data.has_liked;
          if (liked) {
            this.$set(this.reviews[index], 'total_likes', total_likes + 1);
          } else {
            this.$set(this.reviews[index], 'total_likes', total_likes - 1);
          }
          this.$set(this.reviews[index], 'has_liked', liked);
        })
        .catch(() => {
          this.$toasted.global.error('Silahkan coba beberapa saat lagi');
        });
    },
    async requestToDelete(newsfeed_id, index) {
      return new Promise((resolve, reject) => {
        try {
          resolve(this.$MS_SOCO_PUBLIC_API_URL.delete(`/newsfeed/${newsfeed_id}`));
        } catch (error) {
          reject(error);
        }
      })
        .then(() => {
          this.$toasted.global.show('Request untuk menghapus telah dikirim');
        })
        .catch(() => {
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
        })
        .finally(() => {
          this.toggleDropdown(true, index);
        });
    },
    formatVariant(variant) {
      if (variant && variant.match(/,/g) && variant.match(/,/g).length === 1) {
        return variant.replace(',', '');
      }
    },
    editReview(review) {
      const $review = JSON.parse(JSON.stringify(review));
      this.$store.dispatch('setDataModalEditReview', $review);
      this.$store.commit('toggleModalGlobalState', { modalName: 'editReview' });
    },
    toggleReadMore(is_read_more, index) {
      this.$set(this.reviews[index], 'is_read_more', !is_read_more);
    },
    toggleDropdown(is_action_dropdown_open, index) {
      this.$set(this.reviews[index], 'is_action_dropdown_open', !is_action_dropdown_open);
    },
    openModalReport(newsfeed_id, index) {
      this.toggleDropdown(true, index);
      this.$store.commit('setOpenModal', { stateName: 'report', newVal: true });
      this.$store.commit('setNewsfeedIdOfModalReport', newsfeed_id);
    },
    showProductDetail(combination) {
      let variant = '';
      const style = 'width:18px;height:18px;border-radius:50%;margin-right:5px;padding:0;';
      if (combination.attribute) {
        Object.keys(combination.attribute)
          .sort()
          .map((attr, index) => {
            const value = combination.attribute[attr].value || '';
            // add comma to string, except if only one, or last one
            if (index > 0 && index < Object.keys(combination.attribute).length) {
              variant = `${variant} - `;
            }
            if (attr === 'shade' && value) {
              let img = '';
              if (this.isImage(value)) {
                img = `<img src="${value}" style="${style}" />`;
              } else {
                img = `<button style="${style}border:none;background:${value}"></button>`;
              }
              variant = variant + `${img} ${combination.attribute[attr].name}`;
            } else if (attr !== 'non_specify') {
              variant = variant + `${combination.attribute[attr].name}`;
            }
          });
      }
      return variant;
    },
    loginOtf() {
      Auth.CentralAuth.login();
    },
    seeMore() {
      this.$store.commit('setModalSeeMoreReviews', true);
    },
    modalShare(review) {
      const data = { ...review.product };
      data['is_modal_review'] = true;
      data['average_rating'] = review.average_rating || 0;
      data['total_reviews'] = review.product.counter_review_user || 0;
      const images = review.product.images || [];
      const is_cover = this.coverImage(images);
      data['image_cover'] = is_cover ? is_cover.url || '' : images.length > 0 ? images[0].url : '';
      data['from_page'] = 'pdp';
      this.$store.commit('setProductData', data);
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'tellFriends',
      });
    },
    coverImage(images = []) {
      return images.find((image) => image.is_cover);
    },
    isImage(value) {
      if (value && value.search('#') !== -1 && value.length <= 7) {
        return false;
      } else {
        return true;
      }
    },
    reviewer(review) {
      const name = review.name || get(review.user, 'name', '');
      return name.length > 21 ? this.$options.filters.trimName(name) : name;
    },
    showModalReview(data) {
      this.showReadMoreReview = true;
      this.selectedReadMoreReview = data;
    },
  },
};
</script>

<style lang="scss" scoped>
$lato_bold: 'Lato-Bold', sans-serif;
$lato_regular: 'Lato-Regular', sans-serif;

@mixin flexCenter() {
  display: flex;
  align-items: center;
}

.flex {
  display: flex;
  align-items: center;
  &.space-between {
    justify-content: space-between;
  }
  &.flex-start {
    align-items: flex-start;
  }
}
.mt-auto {
  margin-top: auto;
}
.margin-left-10 {
  margin-left: 10px;
}
.review-preview {
  background-color: #fff;
  padding-bottom: 16px;
  &__title {
    padding: 16px 16px 0;
    @media (max-width: 991px) {
      padding: 0 16px;
    }
    h4 {
      margin: 0;
      font-family: $lato_bold;
      font-size: 16px;
      color: #222222;
      letter-spacing: 0;
    }
    p {
      font-family: $lato_regular;
      font-size: 12px;
      color: #8c8582;
      letter-spacing: 0;
      line-height: 18px;
      margin-top: 8px;
      margin-bottom: 8px;
      a {
        font-family: $lato_bold;
        color: $red;
      }
    }
  }
  &__relevant-beauty {
    padding-right: 16px;
    padding-left: 16px;
    &--complete-bp {
      background-repeat: no-repeat;
      background-size: cover;
      font-family: $lato_regular;
      font-size: 12px;
      color: #222222;
      letter-spacing: 0;
      line-height: 20px;
      text-align: left;
      background-image: url('/assets/img/review-personalized-bg2-mobile.svg');
      background-position: top right;
      margin-top: 12px;
      padding: 8px 12px;
      a {
        color: #da2a52;
        font-family: $lato_bold;
      }
      p {
        margin: 0;
      }
      strong {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 8px;
      }
    }
  }
  &__review {
    display: flex;
    overflow: auto;
    // align-items: flex-start;
    margin-top: 16px;
    margin-bottom: 0;
    padding-right: 16px;
    padding-left: 16px;
    &.no-overflow {
      overflow: unset;
    }
    .review-content {
      background: #ffffff;
      border-radius: 4px;
      min-width: 312px;
      // min-height: 311px;
      padding: 16px 12px 12px;
      display: inline-flex;
      flex-direction: column;
      // height: 100%;
      border: 1px solid rgba(229, 229, 229, 1);
      &:not(:last-child) {
        margin-right: 12px;
      }
      &--text {
        margin-bottom: 12px;
      }
      &::v-deep .card-average-rating {
        font-size: 14px;
      }
      &.expert-review {
        background: #fff9fb;
      }
    }
    .review-rating {
      position: relative;
      margin-bottom: 13px;
      .global-rating-inline::v-deep .rating--uniform {
        margin: 0;
      }
    }
    .review-name {
      font-family: $lato_regular;
      font-size: 12px;
      color: #8c8582;
      text-align: right;
      text-transform: capitalize;
    }
    .review-variant:not(:empty) {
      background: #ffffff;
      border: 1px solid #f384a7;
      border-radius: 4px;
      padding: 6px 8px;
      font-family: $lato_regular;
      font-size: 12px;
      color: #222222;
      display: block;
      width: max-content;
      margin-bottom: 12px;
    }
    .review-text {
      font-family: $lato_regular;
      font-size: 14px;
      color: #222222;
      line-height: 22px;
      margin-bottom: 0;
      word-break: break-word;
    }
    .review-photo {
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      &::v-deep .list-user-photo {
        &__item {
          display: flex;
          align-items: center;
        }
        &__img {
          height: 60px;
          width: 60px;
          object-fit: cover;
          border-radius: 4.8px;
          margin-right: 12px;
        }
        &__last-item-text {
          font-family: $lato_regular;
          font-size: 16px;
          color: #222222;
          text-align: right;
          margin: 0;
        }
      }
    }
    .review-likes {
      display: flex;
      .journal-icon--uniform {
        display: flex;
        align-items: center;
        height: unset;
        width: unset;
        font-family: $lato_bold;
        font-size: 13px;
        color: #8c8582;
        text-align: left;
        line-height: 13px;
        &::before {
          height: 16px;
          width: 16px;
          position: initial;
          background-size: 16px 16px;
          margin-right: 8px;
        }
        &.active {
          &::before {
            background-size: 16px 16px;
          }
        }
      }
    }
    .review-action {
      position: relative;
      .journal-icon--uniform {
        a {
          height: 100%;
          width: 100%;
          display: block;
          position: relative;
        }
        &.report:before {
          @media (max-width: 991px) {
            background-size: 16px 16px;
          }
        }
      }
    }
    .review-read-more {
      font-family: $lato_regular;
      display: block;
      color: #da2a52;
      cursor: pointer;
    }
  }
  &__see-more-review {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e5e5e5;
    font-family: $lato_bold;
    font-size: 13px;
    color: #da2a52;
    text-align: left;
    p {
      margin: 0 auto;
      width: max-content;
      cursor: pointer;
    }
  }
}
@media (max-width: 360px) {
  .review-read-more {
    display: block;
  }
}
#pills-dropdown-mobile::v-deep {
  .modal-dialog {
    width: 100%;
    margin: 0;
    align-self: flex-end;
    height: max-content;
    max-height: 585px;
    overflow-y: auto;
    border-radius: 18px 18px 0 0;
    .modal-content {
      .modal-header {
        padding: 0;
        .rectangle-top {
          background: #efefef;
          border-radius: 8px;
          height: 3px;
          width: 38px;
          margin: 8px auto;
        }
        .modal-heading {
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0;
          &--title {
            margin-top: 0;
            margin-bottom: 0;
            font-family: 'lato-bold', sans-serif;
            font-size: 14px;
            color: #231f20;
            letter-spacing: normal;
            line-height: 18px;
          }
          &--close {
            position: initial;
            margin-top: 0;
            line-height: 0;
          }
        }
      }
      .modal-body {
        padding: 0;
        .pills-dropdown-mobile--list {
          margin-bottom: 24px;
          > li {
            padding: 12px 16px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.87);
            text-align: left;
            line-height: 24px;
            &.active {
              @include flexCenter();
              justify-content: space-between;
              p {
                font-family: $lato_bold;
              }
              &::after {
                content: url('/assets/img/icon-check-success-pink.svg');
                line-height: 0;
              }
            }
            &.has-subtags {
              padding: 0;
              margin-bottom: 2px;
            }
            &.apply-button {
              padding: 24px 16px;
              margin-bottom: -24px;
              button {
                width: 100%;
              }
            }
            &:not(.has-subtags) {
              cursor: pointer;
            }
            p {
              margin-top: 0;
              margin-bottom: 0;
              font-family: $lato_regular;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.87);
              text-align: left;
              line-height: 24px;
              &.has-subtags {
                font-family: $lato_bold;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 16px;
                background-color: #f5f5f5;
                cursor: pointer;
                img {
                  transform: rotate(0deg);
                  transition: transform 1s ease-in-out;
                }
                &.expanded {
                  img {
                    transform: rotate(180deg);
                  }
                }
              }
            }
            .rate-star--uniform {
              padding: 0;
              margin: 0;
              width: auto;
              span {
                width: 18px;
                height: 16px;
                background-size: 18px 16px;
                &::before {
                  width: 18px;
                  height: 16px;
                  background-size: 18px 16px;
                }
              }
              .icon_star::before {
                position: relative;
                top: -0.5px;
                margin-left: 1px;
                color: #e5e5e5;
              }
            }
            .subtags {
              max-height: 0;
              overflow: hidden;
              transition: max-height 1s ease-in-out;
              &.expanded {
                max-height: 800px;
              }
              p {
                @include flexCenter();
                padding: 0 16px 0 32px !important;
                margin-top: 16px;
                margin-bottom: 16px;
                input[type='checkbox'] {
                  margin-top: 0;
                  height: 16px;
                  width: 16px;
                  cursor: pointer;
                  &:after {
                    height: 16px;
                    width: 16px;
                    border: 1px solid #e5e5e5;
                    border-radius: 4px;
                    top: 0;
                  }
                  &:checked::after {
                    height: 16px;
                    width: 16px;
                    border: none;
                  }
                }
                label {
                  cursor: pointer;
                  margin: 0;
                  padding: 0;
                  flex: 1;
                }
              }
            }
            .shade-combination {
              @include flexCenter();
              img {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
            &::v-deep {
              .shade-combination--image {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
          }
        }
      }
      .card-review-detail .card-content .right-content .row-rate-detail.score {
        width: calc(100vw - 50px);
      }
      .card-review-detail .trusted-review {
        position: relative;
      }
    }
  }
}
@media (max-width: 991px) {
  .review-content--variant {
    .review-variant {
      max-width: 220px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
</style>
